import { render, staticRenderFns } from "./LocationsView.vue?vue&type=template&id=45c943f0&"
import script from "./LocationsView.vue?vue&type=script&lang=js&"
export * from "./LocationsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports